import React from "react";
import { Trash2, LoaderCircle, Image as ImageIcon } from "lucide-react";
import DragHandle from "./DragHandle";

// Editor row for an image link: title, destination URL and a picker that opens the cropper.
const ImageLinkRow = ({
  input,
  index,
  onChange,
  onLinkBlur,
  onPick,
  onRemove,
  onDragStart,
  onDragEnd,
  onDragOver,
  onDrop,
  dragging,
  t,
}) => (
  <div
    onDragOver={onDragOver}
    onDrop={(event) => onDrop(event, index)}
    className={
      "flex items-center gap-3 bg-slate-50 border border-slate-200 rounded-xl p-2.5 sm:p-3 focus-within:border-indigo-400 focus-within:ring-2 focus-within:ring-indigo-100 transition " +
      (dragging ? "opacity-40" : "")
    }
  >
    <DragHandle index={index} onDragStart={onDragStart} onDragEnd={onDragEnd} t={t} />
    <label
      className={
        "relative w-16 h-16 rounded-lg bg-white shadow-sm flex items-center justify-center shrink-0 overflow-hidden text-slate-300 hover:text-indigo-500 " +
        (input.uploading ? "pointer-events-none" : "cursor-pointer")
      }
      title={t("Image")}
    >
      {input.image_url ? (
        <img className="w-full h-full object-cover" alt={input.social_name || ""} src={input.image_url} />
      ) : (
        <ImageIcon className="w-6 h-6" />
      )}
      {input.uploading && (
        <span className="absolute inset-0 flex items-center justify-center bg-white/70 text-indigo-600">
          <LoaderCircle className="w-5 h-5 animate-spin" />
        </span>
      )}
      <input
        type="file"
        accept="image/jpeg,image/png,image/webp"
        className="hidden"
        disabled={input.uploading}
        onChange={(event) => onPick(input, event)}
      />
    </label>
    <div className="flex-1 min-w-0 space-y-1.5">
      <input
        required
        placeholder={t("Link Title")}
        className="w-full bg-transparent border-0 p-0 focus:outline-none focus:ring-0 text-sm font-medium text-slate-700 placeholder:text-slate-400"
        name="social_name"
        value={input.social_name}
        onChange={(event) => onChange(index, event)}
      ></input>
      <input
        required
        placeholder={t("Link")}
        className="w-full bg-transparent border-0 p-0 focus:outline-none focus:ring-0 text-xs text-slate-500 placeholder:text-slate-400"
        name="link"
        value={input.link}
        onChange={(event) => onChange(index, event)}
        onBlur={() => onLinkBlur(index)}
      ></input>
    </div>
    <button
      type="button"
      className="shrink-0 w-8 h-8 rounded-lg flex items-center justify-center text-slate-300 hover:text-red-500 hover:bg-red-50 transition"
      onClick={() => onRemove(index)}
    >
      <Trash2 className="w-4 h-4" />
    </button>
  </div>
);

export default ImageLinkRow;
